export const theme = {
  colors: {
    default_color: "#F5F5F5",
    white_color: "#FFFFFF",
    black_color: "#000000",
    gray_color: "#CDCDCD",
    primary_color: "#3A8BEB",
    secondary_color: "#255957",
    tertiary_color: "#06D6A0",
    quaternary_color: "#3B2C35",
    quintenary_color: "#E83151",
  },

  fonts: {
    font_size_text_xsmall: "1.2em",
    font_size_text_small: "1.4em",
    font_size_text_medium: "1.6em",
    font_size_text_large: "1.8em",
    font_size_text_xlarge: "2.4em",

    font_size_title: "3em",

    font_size_subtitle: "4em",

    font_weight_contrast: "700",

    font_weight_normal: "400",
  },
};
